import IScalarForm from "src/libs/scalars/interface/IScalarForm"
import { PE_TEST_QUESTION_TYPE } from "../../data/interfaces"
import Range from "../../widgets/answers/Range"
import MultiChoice from "../../widgets/answers/Multichoice"

/* Protopia Ecosystem component */ 
const Answers = (props: IScalarForm): JSX.Element => {
    switch((props.filter || PE_TEST_QUESTION_TYPE.MULTI_CHOOSE).toUpperCase()) {
        case PE_TEST_QUESTION_TYPE.RANGE:
            return <Range {...props} />
        case PE_TEST_QUESTION_TYPE.MULTI_CHOOSE:
        default:
            return <MultiChoice {...props} />
    }
}
export default Answers